import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [admin, setAdmin] = useState(null); // null = loading, false = none, obj = admin
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;
        api.get("/auth/me")
            .then((r) => {
                if (mounted) setAdmin(r.data);
            })
            .catch(() => {
                if (mounted) setAdmin(false);
            })
            .finally(() => mounted && setLoading(false));
        return () => {
            mounted = false;
        };
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        // Persist token as fallback for cross-domain cookie restrictions
        if (data?.access_token) {
            localStorage.setItem("zenith_token", data.access_token);
            api.defaults.headers.common["Authorization"] = `Bearer ${data.access_token}`;
        }
        setAdmin(data.user);
        return data.user;
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch {}
        localStorage.removeItem("zenith_token");
        delete api.defaults.headers.common["Authorization"];
        setAdmin(false);
    };

    return (
        <AuthContext.Provider value={{ admin, loading, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);

// Attach token from localStorage on first load (if present)
const stored = typeof window !== "undefined" ? localStorage.getItem("zenith_token") : null;
if (stored) {
    api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;
}
